/* unplugin-vue-components disabled */const { ref, computed, onMounted, onUpdated } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-54af2fcc"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "drawer-content-wrap"
};
const _hoisted_2 = { style: { "display": "flex", "gap": "5px", "flex-direction": "row-reverse", "align-items": "center" } };
const _hoisted_3 = ["onClick"];
const work_1 = require("@/store/modules/work");
const project_1 = require("@/service/project");
const one_message_1 = require("@/utils/one_message");
const index_vue_1 = tslib_1.__importDefault(require("@/components/RightMenu/index.vue"));
const model_1 = require("@/model");
const loading_1 = require("@/utils/loading");
const router_1 = tslib_1.__importDefault(require("@/router"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Project',
    emits: ['cfgClick', 'addProject', "copyProject"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const drawer = ref(false);
        const projectList = ref([]);
        const emit = __emit;
        const store = (0, work_1.useWork)();
        const dataTotal = ref(1000);
        const curPage = computed(() => router_1.default.currentRoute.value.name);
        const isLaborerPage = computed(() => curPage.value === 'laborer');
        const canClose = computed(() => model_1.Project.current() != null);
        let projects = computed(() => projectList.value.filter(item => {
            if (filterText.value == null || filterText.value === '') {
                return true;
            }
            else {
                return item.p_name.indexOf(filterText.value) >= 0;
            }
        }).map((item) => {
            return ref({
                id: item.pid,
                label: item.p_name,
                isChanging: false
            });
        }));
        __expose({
            show,
            close,
            refreshProjects
        });
        const closeMenu = () => {
            window.dispatchEvent(new Event('click'));
        };
        const handleModifyProject = (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            data.value.isChanging = false;
            let project = projectList.value.find(project => project.pid === data.value.id);
            if (!project)
                return;
            if (data.value.label.length === 0) {
                one_message_1.oneMessage.warning('项目名称不能为空！');
                data.value.label = project.p_name;
                return;
            }
            if (data.value.label.length > 30) {
                one_message_1.oneMessage.warning('项目名称不能超过30个字符！');
                data.value.label = project.p_name;
                return;
            }
            let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
            if (patrn.test(data.value.label)) {
                one_message_1.oneMessage.warning('项目名称不能含有特殊字符，请重新输入！');
                return;
            }
            if (data.value.label.indexOf(" ") !== -1) {
                one_message_1.oneMessage.warning('项目名称不能含有空格！');
                data.value.label = project.p_name;
                return;
            }
            if (projectList.value.find((project) => project.p_name === data.value.label)) {
                if (projectList.value.find((project) => project.p_name === data.value.label && project.pid === data.value.id))
                    return;
                data.value.label = project.p_name;
                one_message_1.oneMessage.warning('已存在同名项目！');
                return;
            }
            (0, loading_1.openLoading)({ text: "重命名中" });
            try {
                yield project_1.ProjectService.current().modifyProjectName(data.value.id, data.value.label);
                yield refreshProjects(1);
            }
            catch (e) {
                console.log(e);
            }
            finally {
                (0, loading_1.closeLoading)();
            }
        });
        function handleNodeClick({ id }) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (id === 0)
                    return;
                if (isNaN(Number(id))) {
                    throw new Error('id is NaN or 0');
                }
                yield project_1.ProjectService.current().loadProjectData(Number(id));
                drawer.value = false;
            });
        }
        const filterText = ref('');
        function refreshProjects(curPage) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let res = yield project_1.ProjectService.current().getAllProjectList();
                if (res) {
                    dataTotal.value = res.total;
                    projectList.value.splice(0, projectList.value.length);
                    projectList.value.push(...res.project_infos);
                }
                else {
                    (0, one_message_1.oneMessage)({
                        type: 'error',
                        message: '获取工程数据失败'
                    });
                }
            });
        }
        onMounted(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield refreshProjects(1);
        }));
        onUpdated(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield refreshProjects(1);
        }));
        function getServeTime() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                return new Date().getTime();
            });
        }
        function createRightMenuData(data) {
            return [
                {
                    label: '重命名',
                    id: data.value.id,
                    icon: 'pen',
                    clickClose: true,
                    onClick: () => {
                        data.value.isChanging = true;
                    }
                },
                {
                    label: '复制',
                    id: data.value.id,
                    icon: 'copy',
                    clickClose: true,
                    onClick: () => {
                        emit('copyProject', data.value.id);
                    }
                },
                {
                    label: '删除',
                    confirmMsg: `确定删除"${data.value.label}"吗？`,
                    id: data.value.id,
                    icon: 'trash-alt',
                    onClick: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        yield project_1.ProjectService.current().delProject(data.value.id);
                        refreshProjects(1);
                    })
                }
            ];
        }
        function show() {
            drawer.value = true;
        }
        function close() {
            drawer.value = false;
        }
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_divider = (0, vue_2.resolveComponent)("el-divider");
            const _component_el_input = (0, vue_2.resolveComponent)("el-input");
            const _component_el_drawer = (0, vue_2.resolveComponent)("el-drawer");
            const _directive_auto_focus = (0, vue_2.resolveDirective)("auto-focus");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_drawer, {
                "modal-class": "project-panel",
                modelValue: (0, vue_2.unref)(drawer),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((0, vue_2.isRef)(drawer) ? (drawer).value = $event : null)),
                direction: "ltr",
                size: "350px;",
                title: "我的项目",
                "with-header": false,
                "close-on-click-modal": (0, vue_2.unref)(canClose),
                "close-on-press-escape": (0, vue_2.unref)(canClose)
            }, {
                default: (0, vue_2.withCtx)(() => [
                    true
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (!(0, vue_2.unref)(isLaborerPage))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                        key: 0,
                                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('addProject'))),
                                        type: "primary",
                                        style: { "margin-right": "5px" }
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)(" 新建 ")
                                        ]),
                                        _: 1
                                    }))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            (0, vue_2.createVNode)(_component_el_divider, { "content-position": "left" }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(isLaborerPage) ? '我的工位' : '工作目录'), 1)
                                ]),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_input, {
                                size: "default",
                                class: "filter-input",
                                modelValue: (0, vue_2.unref)(filterText),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((0, vue_2.isRef)(filterText) ? (filterText).value = $event : null)),
                                placeholder: "搜索项目关键词"
                            }, null, 8, ["modelValue"]),
                            (0, vue_2.createElementVNode)("div", {
                                class: "project-list-wrap",
                                direction: "vertical",
                                size: "large",
                                onScroll: closeMenu
                            }, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(projects), (item) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(index_vue_1.default, {
                                        key: item.value.id,
                                        data: createRightMenuData(item),
                                        class: "project-item",
                                        onContextmenu: (0, vue_2.withModifiers)(closeMenu, ["right"]),
                                        onTouchstart: closeMenu
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (item.value.isChanging)
                                                ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_input, {
                                                    key: 0,
                                                    modelValue: item.value.label,
                                                    "onUpdate:modelValue": ($event) => ((item.value.label) = $event),
                                                    onKeydown: [
                                                        (0, vue_2.withKeys)(($event) => (item.value.isChanging = false), ["enter"]),
                                                        _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                                    ],
                                                    onBlur: ($event) => (handleModifyProject(item)),
                                                    size: "small"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])), [
                                                    [_directive_auto_focus]
                                                ])
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", {
                                                onClick: ($event) => (handleNodeClick(item.value)),
                                                class: "project-name"
                                            }, (0, vue_2.toDisplayString)(item.value.label), 9, _hoisted_3), [
                                                [vue_2.vShow, !item.value.isChanging]
                                            ])
                                        ]),
                                        _: 2
                                    }, 1032, ["data"]));
                                }), 128))
                            ], 32)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                _: 1
            }, 8, ["modelValue", "close-on-click-modal", "close-on-press-escape"]));
        };
    }
});
